import { takeLatest, put } from 'redux-saga/effects';
import { buscarQuantidadeAutorizacoesRequisicoesService, buscarQuantidadeNotificacoesRequisicoesService } from '../services/core/processos/processosRequisicoesService';
import {
  findQuantidadeRequisicoesAction, FIND_QUANTIDADE_REQUISICOES, INITIALIZE_MENU, setQuantidadeNotificacoesAction,
  FIND_QUANTIDADE_AUTORIZACOES,
  setQuantidadeAutorizacoesAction,
  findQuantidadeAutorizacoesAction,
} from './theme.actions';

export function* inializePageHandler() {
  yield put(findQuantidadeRequisicoesAction());
  yield put(findQuantidadeAutorizacoesAction());
}

export function* findQuantidadeRequisicoesHandler() {
  try {
    const quantidadeRequisicoes = yield buscarQuantidadeNotificacoesRequisicoesService();
    yield put(setQuantidadeNotificacoesAction(quantidadeRequisicoes?.data || 0));
  } catch (e) {
    yield put(setQuantidadeNotificacoesAction(0));
  }
}

export function* findQuantidadeAutorizacoesHandler() {
  try {
    const quantidadeAutorizacoes = yield buscarQuantidadeAutorizacoesRequisicoesService();
    yield put(setQuantidadeAutorizacoesAction(quantidadeAutorizacoes?.data || 0));
  } catch (e) {
    yield put(setQuantidadeAutorizacoesAction(0));
  }
}

export function* watchSagaMenu() {
  yield takeLatest(INITIALIZE_MENU, inializePageHandler);
  yield takeLatest(FIND_QUANTIDADE_REQUISICOES, findQuantidadeRequisicoesHandler);
  yield takeLatest(FIND_QUANTIDADE_AUTORIZACOES, findQuantidadeAutorizacoesHandler);
}
